"use client";
import { jsx } from "react/jsx-runtime";
import { SpaceXs, SpaceXxs, SpaceSm } from "@nxt-costco-com/forge-design-tokens";
import { ChevronLeft, ChevronRight } from "@nxt-costco-com/forge-icons";
import { PREVIOUS_BUTTON_TEST_ID, NEXT_BUTTON_TEST_ID } from "./constants.js";
import { CarouselNavigationButton, chevronStylesSx } from "./styles.js";
import { NavigationButtonWrapper } from "../NavigationButtonWrapper/index.js";
import useCheckScreen from "../../../../hooks/useCheckScreen/index.js";
const NavigationButton = ({
  ariaLabel,
  carousel,
  direction,
  isVisible,
  navigationButtonBottomOffset = "auto",
  navigationButtonTopOffset = "auto",
  onButtonAutoplayClick,
  onButtonBlur,
  onButtonFocus,
  innerRef,
  isScrollbar
}) => {
  const { isMobile } = useCheckScreen();
  const bottomControlSpacing = isMobile ? `${SpaceXs}` : `${SpaceXxs}`;
  if (!isVisible) {
    return null;
  }
  const [_carouselRef, carouselApi] = carousel;
  const onClick = () => {
    if (direction === "previous") {
      (carouselApi == null ? void 0 : carouselApi.scrollPrev) && onButtonAutoplayClick(carouselApi == null ? void 0 : carouselApi.scrollPrev);
    } else {
      (carouselApi == null ? void 0 : carouselApi.scrollNext) && onButtonAutoplayClick(carouselApi == null ? void 0 : carouselApi.scrollNext);
    }
  };
  const isPrevious = direction === "previous";
  const computedStyles = {
    marginLeft: isPrevious ? `-${SpaceSm}` : void 0,
    marginRight: !isPrevious ? `-${SpaceSm}` : void 0,
    left: isPrevious ? bottomControlSpacing : void 0,
    right: !isPrevious ? bottomControlSpacing : void 0
  };
  return /* @__PURE__ */ jsx(NavigationButtonWrapper, { isScrollbar, sx: computedStyles, children: /* @__PURE__ */ jsx(
    CarouselNavigationButton,
    {
      sx: !isScrollbar ? computedStyles : {},
      "aria-label": ariaLabel,
      "data-testid": isPrevious ? PREVIOUS_BUTTON_TEST_ID : NEXT_BUTTON_TEST_ID,
      name: direction,
      navigationButtonBottomOffset,
      navigationButtonTopOffset,
      onBlur: onButtonBlur,
      onClick,
      onFocus: onButtonFocus,
      ref: innerRef,
      isScrollbar,
      children: isPrevious ? /* @__PURE__ */ jsx(ChevronLeft, { sx: chevronStylesSx }) : /* @__PURE__ */ jsx(ChevronRight, { sx: chevronStylesSx })
    }
  ) });
};
export {
  NavigationButton
};
